
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { HisSharedModule } from 'hisng';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ConfirmationDialogComponent } from './confirmation-dialogs/component/confirmation-dialog.component';
import { InformationDialogComponent } from './confirmation-dialogs/component/information-dialog.component';



/**
 * CoreModule for common components.
 */
@NgModule( {
    imports: [
        CommonModule,

        // primeng
        ConfirmDialogModule,

        // HIS
        HisSharedModule,
    ],
    declarations: [
        ConfirmationDialogComponent,
        InformationDialogComponent
    ],
    exports: [
        ConfirmationDialogComponent,
        InformationDialogComponent
    ]
    // NO PROVIDERS! Providers need to go into CommonCoreModule
} )

export class CommonSharedModule {
}
